import * as angular from 'angular';

import CoreLayoutHeaderModule from './header/coreLayoutHeader.module';

import FileExtensionFilter from './fileExtension.filter';
import { AptFileUploadComponent } from './fileUpload/aptFileUpload.component';
import { AptFileUploadSummaryComponent } from './fileUpload/aptFileUploadSummary.component';
import { AptFileAttachmentsService } from './fileUpload/aptFileAttachments.service';
import FileTypeFilter from './fileType.filter';

import { aptHighlightTextFilter } from './aptHighlightText.filter';
import { AptModalComponent } from './aptModal.component';
import { AptRecaptchaComponent } from './aptRecaptcha.component';
import {
  AptToolbarComponent,
  ToolbarStackComponent
} from './aptToolbar.component';
import CoverageMeterDirective from './coverageMeter.directive';
import { DetailsAccordionComponent } from './detailsAccordion.component';
import FeatureListFactory from './featureList.factory';
import { IconWithHover } from './iconWithHover.component';
import LayoutFactory from './layout.factory';
import MrStickyDirective from './mrSticky.directive';
import NavMessagesFactory from './navMessages.factory';
import PricingModelFactory from './pricingModel.factory';
import { RequestDetailsSummaryComponent } from './requestDetailsSummary.component';
import { SearchComponent } from './search.component';
import SpendDatesAndOfferTypeDirective from './spendDatesAndOfferType.directive';
import { TitleAndSubtitleComponent } from './titleAndSubtitle.component';
import ToggleIconDirective from './toggleIcon.directive';
import { TrayComponent } from './tray.component';
import { SpendAndSavingsSummaryComponent } from './spendAndSavingsSummary/spendAndSavingsSummary.component';

// TODO: Move this outside of core if it needs the Navigation module - core should not have any dependencies
// httpInterceptor should be moved inside core, so that's not an issue
export default angular
  .module('coreLayout', ['httpInterceptor', CoreLayoutHeaderModule])
  // File Upload components
  .component('aptFileUpload', AptFileUploadComponent)
  .component('aptFileUploadSummary', AptFileUploadSummaryComponent)
  .service('AptFileAttachments', AptFileAttachmentsService)
  .filter('fileExtension', FileExtensionFilter)
  .filter('fileType', FileTypeFilter)
  // Other components
  .component('aptModal', AptModalComponent)
  .component('aptRecaptcha', AptRecaptchaComponent)
  .component('aptToolbar', AptToolbarComponent)
  .directive('coverageMeterNew', CoverageMeterDirective)
  .component('detailsAccordion', DetailsAccordionComponent)
  .component('iconWithHover', IconWithHover)
  .directive('mrSticky', MrStickyDirective)
  .component('requestDetailsSummary', RequestDetailsSummaryComponent)
  .component('search', SearchComponent)
  .directive('spendDatesAndOfferType', SpendDatesAndOfferTypeDirective)
  .component('titleAndSubtitle', TitleAndSubtitleComponent)
  .directive('toggleIcon', ToggleIconDirective)
  .component('toolbarStack', ToolbarStackComponent)
  .component('tray', TrayComponent)
  .component('spendAndSavingsSummary', SpendAndSavingsSummaryComponent)

  // Filters
  .filter('aptHighlightText', aptHighlightTextFilter)

  // Services
  .factory('FeatureList', FeatureListFactory)
  .factory('LayoutService', LayoutFactory)
  .factory('NavMessages', NavMessagesFactory)
  .factory('PricingModel', PricingModelFactory).name;
